// ========================================
// 토큰 관리 유틸리티 함수들
// ========================================

// 토큰 저장소 키
export const TOKEN_KEYS = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  TOKEN_EXPIRY: "tokenExpiry",
} as const;

// ========================================\
// Cookie 관리 유틸리티 함수들\ (삭제의 경우 서버에서 수행해야함)
// ========================================\
export const setCookie = (name: string, value: string, days: number = 7, path: string = '/') => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path + '; SameSite=Lax; Secure';
};

const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.charAt(0);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
};



// 토큰 정보 타입
export interface TokenInfo {
  accessToken: string;
  refreshToken?: string;
  expiresIn?: number;
}

// 토큰 저장
export const saveTokens = (tokens: TokenInfo): void => {
  let cookieDays = 7; // Default for refresh token if not specified
  // if (tokens.expiresIn) {
  //   // Convert seconds to days for cookie expiry. Minimum 1 day.
  //   cookieDays = Math.max(1, Math.ceil(tokens.expiresIn / (24 * 60 * 60)));
  //   const expiryTime = Date.now() + tokens.expiresIn * 1000;
  //   setCookie(TOKEN_KEYS.TOKEN_EXPIRY, expiryTime.toString(), cookieDays);
  // }

  // if (tokens.accessToken) {
  //   setCookie(TOKEN_KEYS.ACCESS_TOKEN, tokens.accessToken, cookieDays);
  // }

  // if (tokens.refreshToken) {
  //   setCookie(TOKEN_KEYS.REFRESH_TOKEN, tokens.refreshToken, cookieDays);
  // }
};


// // 액세스 토큰 가져오기
// export const getAccessToken = (): string | null => {
//   return getCookie(TOKEN_KEYS.ACCESS_TOKEN);
// };

// // 리프레시 토큰 가져오기
// export const getRefreshToken = (): string | null => {
//   return getCookie(TOKEN_KEYS.REFRESH_TOKEN);
// };

// 토큰 만료 시간 가져오기
export const getTokenExpiry = (): number | null => {
  const expiry = getCookie(TOKEN_KEYS.TOKEN_EXPIRY);
  return expiry ? parseInt(expiry) : null;
};

// 토큰이 유효한지 확인
export const isTokenValid = (): boolean => {
  // const token = getAccessToken();
  // if (!token) return false;

  // const expiry = getTokenExpiry();
  // if (expiry && Date.now() > expiry) {
  //   // 토큰이 만료되었으면 자동으로 제거
  //   // clearTokens();
  //   return false;
  // }

  return true;
};

// 토큰이 곧 만료될 예정인지 확인 (5분 전)
export const isTokenExpiringSoon = (): boolean => {
  const expiry = getTokenExpiry();
  if (!expiry) return false;

  const fiveMinutes = 5 * 60 * 1000; // 5분
  return expiry - Date.now() < fiveMinutes;
};

// 모든 토큰 제거
export const clearTokens = (): void => {

  // localStorage에서도 제거
  localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);

  // login-session 내부의 토큰 제거
  try {
    const sessionData = localStorage.getItem("login-session");
    if (sessionData) {
      const session = JSON.parse(sessionData);
      if (session && typeof session === "object") {
        session.accessToken = "";
        session.refreshToken = "";
        localStorage.setItem("login-session", JSON.stringify(session));
      }
    }
  } catch (error) {
    console.error("Error clearing tokens from login-session:", error);
  }
};

// JWT 토큰 페이로드 디코딩
export const decodeJwtPayload = (token: string): any => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("JWT 디코딩 실패:", error);
    return null;
  }
};

// 토큰에서 사용자 정보 추출
export const extractUserInfo = (token: string): any => {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;

  return {
    userId: payload.sub || payload.userId,
    username: payload.username || payload.name,
    roles: payload.roles || payload.authorities || [],
    permissions: payload.permissions || [],
    exp: payload.exp,
    iat: payload.iat,
  };
};

// 토큰 갱신이 필요한지 확인
export const shouldRefreshToken = (): boolean => {
  if (!isTokenValid()) return false;

  // 토큰이 곧 만료될 예정이거나 이미 만료된 경우
  return isTokenExpiringSoon();
};

// 토큰 상태 정보 가져오기
// export const getTokenStatus = () => {
//   const hasAccessToken = !!getAccessToken();
//   const hasRefreshToken = !!getRefreshToken();
//   const isValid = isTokenValid();
//   const isExpiringSoon = isTokenExpiringSoon();

//   return {
//     hasAccessToken,
//     hasRefreshToken,
//     isValid,
//     isExpiringSoon,
//     needsRefresh: hasAccessToken && (isExpiringSoon || !isValid),
//   };
// };

// 토큰 정보 로깅 (디버깅용)
export const logTokenInfo = (): void => {
  // const status = getTokenStatus();
  // const accessToken = getAccessToken();
  // const refreshToken = getRefreshToken();

  // console.log("🔐 토큰 상태:", {
  //   ...status,
  //   accessTokenLength: accessToken?.length || 0,
  //   refreshTokenLength: refreshToken?.length || 0,
  //   hasValidToken: status.isValid,
  // });

  // if (accessToken) {
  //   const userInfo = extractUserInfo(accessToken);
  //   console.log("👤 사용자 정보:", userInfo);
  // }
};

// 디버깅: localStorage의 모든 토큰 관련 키 확인
export const debugTokens = (): void => {
  // console.log("🔍 토큰 디버깅 시작");
  // // console.log("📋 localStorage 모든 키:", Object.keys(localStorage)); // Commented out as tokens are now in cookies

  // // 직접 저장된 토큰들 (쿠키에서 가져옴)
  // console.log("🔑 accessToken:", getCookie(TOKEN_KEYS.ACCESS_TOKEN) ? "***" : "없음");
  // console.log("🔑 refreshToken:", getCookie(TOKEN_KEYS.REFRESH_TOKEN) ? "***" : "없음");
  // console.log("🔑 tokenExpiry:", getCookie(TOKEN_KEYS.TOKEN_EXPIRY));

  // console.log("🔍 토큰 디버깅 완료");
};
